module.exports = __webpack_public_path__ + "static/media/halugen-iphone-slide2.96f91a25.jpg";